module.exports = __webpack_public_path__ + "assets/img/free.7bd27f43.png";